import React, { useState } from "react";
import { Badge, Button, CircularProgress } from "@material-ui/core";
import * as S from "./styles";
import * as _ from "lodash";
import { Add, Send } from "@material-ui/icons";
import ThumbPreview from "./ThumbPreview";
import { useTranslation } from "react-i18next";

function ShowImages({
  previews,
  onSubmit,
  loading,
  addNewImages,
  removeImage,
}) {
  const [indexPreview, setIndexPreview] = useState(0);
  const { t } = useTranslation([]);

  return (
    <S.Container>
      <S.ImageContent>
        <S.Preview
          style={{ backgroundImage: `url(${previews[indexPreview]})` }}
        />
      </S.ImageContent>

      <S.FooterContainer>
        <S.FooterImage>
          <S.ListPreview>
            {previews.map((preview, index) => (
              <ThumbPreview
                style={{
                  backgroundImage: `url(${preview})`,
                }}
                key={preview}
                preview={preview}
                selected={index == indexPreview}
                onClick={() => setIndexPreview(index)}
                removeImage={() => removeImage(index)}
              />
            ))}
          </S.ListPreview>

          <S.AddNewImage>
            <Add style={{ fontSize: 38 }} />

            <input
              type="file"
              accept="image/*"
              hidden
              multiple
              onChange={addNewImages}
            />
          </S.AddNewImage>
        </S.FooterImage>

        <S.Actions>
          <Badge color="secondary" badgeContent={previews.length}>
            <Button
              color="primary"
              variant="contained"
              component="label"
              disabled={previews.length == 0 || loading}
              onClick={onSubmit}
              style={{ height: 50, borderRadius: 50 }}
              startIcon={loading ? <CircularProgress /> : <Send />}
            >
              {t("Chat:attachment.send")}
            </Button>
          </Badge>
        </S.Actions>
      </S.FooterContainer>
    </S.Container>
  );
}

export default ShowImages;
